<template>
  <div v-if="this.language == 'eng'" class="eng">
    <div class="image_9" v-if="this.active == 9">
      <div class="text eng_text">News Updates</div>
    </div>
    <div class="image_12" v-else-if="this.active == 12">
      <div class="text eng_text">Inherit</div>
    </div>
    <div class="image_3" v-else-if="this.active == 3">
      <div class="text eng_text">Database</div>
    </div>
    <div class="image_2" v-else-if="this.active == 2">
      <div class="text eng_text">Regong Works Exhibition</div>
    </div>
    <div class="image_5" v-else-if="this.active == 5">
      <div class="text eng_text">
        Cultural and Creative Design Exhibition and Sales
      </div>
    </div>
    <div class="image_4" v-else-if="this.active == 4">
      <div class="text eng_text">Regong Exhibition and Sales</div>
    </div>
  </div>
  <div v-else-if="this.language == 'en'">
    <div class="image_9" v-if="this.active == 9">
      <div class="text za_text">གསར་འགྱུར་གནས་ཚུལ།</div>
    </div>
    <div class="image_12" v-else-if="this.active == 12">
      <div class="text za_text">རྒྱུན་འཛིན་པ།</div>
    </div>
    <div class="image_3" v-else-if="this.active == 3">
      <div class="text za_text">གྲངས་མཛོད།</div>
    </div>
    <div class="image_2" v-else-if="this.active == 2">
      <div class="text za_text">རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།</div>
    </div>
    <div class="image_5" v-else-if="this.active == 5">
      <div class="text za_text">རིག་གཏོད་ཇུས་འགོད་དང་འགྲེམ་འཚོང་།</div>
    </div>
    <div class="image_4" v-else-if="this.active == 4">
      <div class="text za_text">རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་འཚོང་།</div>
    </div>
  </div>
  <div v-else>
    <div class="image_9" v-if="this.active == 9">
      <div class="text">新闻动态</div>
    </div>
    <div class="image_12" v-else-if="this.active == 12">
      <div class="text">传承人</div>
    </div>
    <div class="image_3" v-else-if="this.active == 3">
      <div class="text">数据库</div>
    </div>
    <div class="image_2" v-else-if="this.active == 2">
      <div class="text">热贡作品展</div>
    </div>
    <div class="image_5" v-else-if="this.active == 5">
      <div class="text">文创设计与展销</div>
    </div>
    <div class="image_4" v-else-if="this.active == 4">
      <div class="text">热贡作品展销</div>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
    "$route.path": {
      handler(toPath, fromPath) {
        if (toPath == "/index") {
          this.active = 1;
        } else if (
          toPath == "/exhibition" ||
          toPath == "/exhibitionDetail" ||
          toPath == "/exhibitionWorkDetail" ||
          toPath == "/paintingExhibition" ||
          toPath == "/exhibitionWork" ||
          toPath == "/exhibitionBaseDetail" ||
          toPath == "/exhibitionSearch" ||
          toPath == "/exhibitionSearchDetails"
        ) {
          this.active = 2;
        } else if (
          toPath == "/exhibitionSale" ||
          toPath == "/exhibitionSearchDetail" ||
          toPath == "/exhibitionMade" ||
          toPath == "/exhibitionSaleSearchDetail" ||
          toPath == "/exhibitionSaleSearch"
        ) {
          this.active = 4;
        } else if (
          toPath == "/culture" ||
          toPath == "/culturalGoodsDetail" ||
          toPath == "/culturalMoreGoods" ||
          toPath == "/culturalCustomMade" ||
          toPath == "/culturalCustomSearchDetail" ||
          toPath == "/culturalCustomDetail"
        ) {
          this.active = 5;
        } else if (
          toPath == "/database" ||
          toPath == "/dataBaseWork" ||
          toPath == "/dataBaseDetail" ||
          toPath == "/dataBaseSearchDetail" ||
          toPath == "/dataBaseSearch"
        ) {
          this.active = 3;
        } else if (toPath == "/news" || toPath == "/newsDetail") {
          this.active = 9;
        } else if (toPath == "/about") {
          this.active = 10;
        } else if (toPath == "/inheritDetail" || toPath == "/inherit") {
          this.active = 12;
        }
      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  data() {
    return {
      active: 1,
      language: this.$store.state.language,
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
};
</script>
<style lang="scss">
.image_9,
.image_12,
.image_3,
.image_2,
.image_5,
.image_4 {
  position: relative;
  height: 580px;
  background-size: 100% 100% !important;
  .text {
    text-align: center;
    width: 2.5rem;
    position: absolute;
    top: 50%;
    right: 0;
    white-space: normal;
    transform: translate(0, -50%);
    color: #fff;
    font-size: 82px;
    font-family: "fangzang";
  }
  .za_text {
    font-size: 90px;
  }
  .eng_text {
    font-family: "Times New Roman", Times, serif;
    font-size: 80px;
  }
}
.image_9 {
  background: url("../assets/newImage/swiper/3-1.jpg") no-repeat center center;
}
.image_4 {
  background: url("../assets/newImageBgc/newImage_2.png") no-repeat center
    center;
}
.image_12 {
  background: url("../assets/newImage/swiper/inherit_bgc.jpg") no-repeat center center;
}
.image_3 {
  background: url("../assets/newImageBgc/newImage_6.png") no-repeat center
    center;
}
.image_2 {
  background: url("../assets/newImageBgc/newImage_1.png") no-repeat center
    center;
}
.image_5 {
  background: url("../assets/newImageBgc/newImage_5.png") no-repeat center
    center;
}
@media (max-width: 768px) {
  .image_9,
  .image_12,
  .image_3,
  .image_2,
  .image_5,
  .image_4 {
    background-size: cover !important;
    height: 3.4rem;
    position: relative;
    .text {
      font-size: 0.5rem !important;
      left: 59%;
    }
    .za_text {
      font-size: 0.3rem !important;
      left: 59%;
    }
  }
  .image_9 {
    background: url("../assets/newImage/mobile/index/3-1.jpg") no-repeat center
      center;
  }
  .image_4 {
    background: url("../assets/newImage/mobile/topBgc/saleBgc.jpg") no-repeat
      center center;
  }
  .image_12 {
    background: url("../assets/newImage/mobile/index/inherit_bgc.jpg") no-repeat center
      center;
  }
  .image_2 {
    background: url("../assets/newImageBgc/mobile_newImage_1.jpg") no-repeat
      center center;
  }
  .image_3 {
    background: url("../assets/newImageBgc/mobileDateBaseBgc.jpg") no-repeat
      center center;
  }
  .image_5 {
    background: url("../assets/newImageBgc/mobileCultrueBgc.jpg") no-repeat
      center center;
  }
}
</style>